/**
 * @author Sai Prasad
 * @class ContentBlock
 */
import React from 'react';

const ContentBlock = ({
    content
}) => {
    return (
        <div className='intro__introDiv'>
            <span className='intro__introContent'>{content}</span>
        </div>
    )
}
export default ContentBlock;